import React from 'react';
import { CardIconProps } from './types';

function AmexIcon({ size = '2em' }: CardIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 300 300">
      <defs>
        <radialGradient
          cx="16.668%"
          cy="17.162%"
          fx="16.668%"
          fy="17.162%"
          r="117.5%"
          id="prefix__amex"
        >
          <stop stopColor="#86D4F7" offset="0%" />
          <stop stopColor="#7FCFF4" offset="7.54%" />
          <stop stopColor="#6BC4EE" offset="18.14%" />
          <stop stopColor="#43B3E6" offset="30.5%" />
          <stop stopColor="#19A9E1" offset="37.08%" />
          <stop stopColor="#139FDA" offset="43.61%" />
          <stop stopColor="#0E90D0" offset="56.34%" />
          <stop stopColor="#0C86C8" offset="69.64%" />
          <stop stopColor="#0A80C4" offset="83.74%" />
          <stop stopColor="#0A7EC2" offset="100%" />
        </radialGradient>
      </defs>
      <g fill="none" fillRule="nonzero">
        <path fill="url(#prefix__amex)" d="M0 0h300v300H0z" />
        <path
          d="M66.33 168.89l-3.746 8.78H29L55.503 122h63.302l6.39 12.295L131.164 122H216.507l7.295 7.643 7.834-7.643h39.632l-28.138 27.77 26.924 27.9H231.7l-8.581-8.2-8.51 8.2H77.706l-4.12-8.78H66.33zm7.279.588h-7.303 7.303zm81.12-39.525h-16.668l-12.541 26.642-13.494-26.642H95.357v38.571l-17.224-38.571H62.496l-18.415 39.764h11.272l3.73-9.066h21.431l4.286 9.066h20.717V137.35l14.685 32.368h9.683l14.606-31.811v31.811h10.239v-39.764zm68.819 12.883l-11.907-12.883h-47.783v39.764h46.196l13.097-13.043 13.176 13.043h12.303l-18.812-20.12 19.367-19.644h-12.858l-12.78 12.883zm-25.162 18.928h-24.289v-8.748h24.289v-7.953h-24.289v-7.157h24.289v-6.76l18.017 18.052-18.017 18.133v-5.567zm-128.35-25.29l6.986 16.144H62.496l7.54-16.144z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default AmexIcon;
